<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span class="d-md-inline d-none" ></span>
                    <span class="d-md-inline d-none"></span>
                    <span class="d-md-inline d-none"></span>
                    <span class="d-md-inline d-none"></span>
                    <span class="d-md-inline d-none"></span>
                    <span class="d-md-inline d-none"></span>
                    <span class="d-md-inline d-none"></span>
                    <span class="d-md-inline d-none"></span>
                    <span class="d-md-inline d-none"></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-2 text-white">Auxílio Maternidade
                                    <span>Você pode ter direito ao benefício !</span>
                                </h1>
                                <p class="lead text-white font-weight-bold">LIBERAMOS DE R$ 4.100,00 A R$ 13.900,00</p>
                                <div class="btn-wrapper">
                                  <a onclick="handleButton()" class="btn_whats btn-lead-button">
                                    <i class="fa fa-whatsapp mr-2"></i>
                                    <span class="nav-link-inner--text">Falar pelo WhatsApp</span>
                                  </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-diamond" type="my-primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="txt-primary text-uppercase">10 Anos de Experiência</h6>
                                    <p class="description mt-3">A AMO, é uma assessoria previdenciária que se preocupa com os
                                      direitos dos cidadãos e principalmente com os direitos das mães.</p>
                                  <a onclick="handleButton()"
                                     class="txt-primary mt-5 btn-lead-button">Receber meu benefício</a>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-female" type="my-secondary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="txt-secondary text-uppercase">2.389 Mães Receberam seu Benefício</h6>
                                    <p class="description mt-3">Garantimos uma assessoria de qualidade e sem burocracia.</p>
                                  <a onclick="handleButton()"
                                     class="txt-secondary mt-5 btn-lead-button">Quero ser mais uma mãe</a>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="fa fa-line-chart" type="my-text-logo" rounded class="mb-4">
                                    </icon>
                                    <h6 class="txt-logo text-uppercase">98% de Taxa de Aprovação</h6>
                                    <p class="description mt-3">Nossos profissionais são especialistas na área e temos uma
                                      larga experiência previdenciária.</p>
                                  <a onclick="handleButton()"
                                     class="txt-logo mt-5 btn-lead-button">Quero ser aprovada</a>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div>
                            <img v-lazy="'img/baby-section.png'" class="card-img-top">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                          <div class="btn-wrapper mb-5">
                            <a onclick="handleButton()" class="btn_whats btn-lead-button">
                              <i class="fa fa-whatsapp mr-2"></i>
                              <span class="nav-link-inner--text">Quero receber o Benefício</span>
                            </a>
                          </div>
                            <p class="display-3">AMO, a empresa que nasceu para ajudar você que tem direito ao
                              Auxílio Maternidade</p>
                            <p class="p-txt">Nossos especialistas vão solicitar alguns documentos para uma análise interna e,
                              após isso, se você estiver dentro das exigências, protocolaremos sua solicitação
                              através dos nossos advogados.</p>
                            <a onclick="handleButton()"
                               class="font-weight-bold txt-primary mt-5 btn-lead-button">Solicitar Agora Meu Benefício</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-2 shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-6 order-lg-1">
                        <div class="d-flex px-3">
                            <div class="pl-4">
                                <h4 class="display-3 text-white">A AMO SABE SE VOCÊ TEM DIREITO!</h4>
                            </div>
                        </div>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-check"  color="white" gradient="my-primary" shadow
                                          rounded></icon>
                                </div>
                                <div class="pl-4">
                                    <h5 class="title txt-primary">Não perca a oportunidade</h5>
                                    <p>Nossos profissionais são especialistas na área e temos uma larga
                                      experiência previdenciária, tudo isso, para sanar todas as dúvidas do cidadão em
                                      relação aos direitos garantidos por lei.</p>
                                </div>
                            </div>
                        </card>
                        <card shadow class="shadow-lg--hover mt-5">
                            <div class="d-flex px-3">
                                <div>
                                    <icon name="fa fa-thumbs-o-up" color="white" gradient="my-secondary" shadow
                                          rounded></icon>
                                </div>
                                  <div class="pl-4">
                                    <h5 class="title txt-secondary">É um Direito Seu</h5>
                                    <p>Nosso compromisso é fazer com que o cidadão receba todos os
                                      benefícios que tem direito de forma rápida, prática e com uma assessoria
                                      de qualidade.</p>
                                  </div>
                            </div>
                        </card>
                      <div class="section-bt-center">
                        <div class="btn-wrapper mt-5">
                          <a onclick="handleButton()" class="btn_whats btn-lead-button">
                            <i class="fa fa-whatsapp mr-2"></i>
                            <span class="nav-link-inner--text">Saber se tenho Direito</span>
                          </a>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">Depoimentos</h2>
                        <p class="lead text-muted">Com mais de 10 anos de experiência no mercado, a AMO,
                          já atendeu milhares de mães em todo Brasil e tem uma taxa de aprovação do benefício de 98%.</p>
                    </div>
                </div>
                <!-- Vídeos -->
                <div class="row">
                    <div class="col-md-6 col-lg-6 mb-5 mb-lg-0">
                        <div class="px-4">
                            <b-embed
                                type="iframe"
                                aspect="1by1"
                                src="https://www.youtube.com/embed/MxtkOZQ4SBg"
                            />
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Jaqueline | Rio Grande do Sul</span>
                                    <small class="h6 text-muted">Atendemos em todo Brasil</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                  <div class="col-md-6 col-lg-6 mb-5 mb-lg-0">
                    <div class="px-4">
                      <b-embed
                          aspect="1by1"
                          src="https://www.youtube.com/embed/BWkx-eEmBA4"
                      />
                      <div class="pt-4 text-center">
                        <h5 class="title">
                          <span class="d-block mb-1">Natália | Rio de Janeiro</span>
                          <small class="h6 text-muted">Atendemos em todo Brasil</small>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 mb-5 mb-lg-0">
                    <div class="px-4">
                      <b-embed
                          aspect="1by1"
                          src="https://www.youtube.com/embed/v7DErJP1kVE"
                      />
                      <div class="pt-4 text-center">
                        <h5 class="title">
                          <span class="d-block mb-1">Gessiane | Rio de Janeiro</span>
                          <small class="h6 text-muted">Atendemos em todo Brasil</small>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 mb-5 mb-lg-0">
                    <div class="px-4">
                      <b-embed
                          aspect="1by1"
                          src="https://www.youtube.com/embed/LU131mHJf1g"
                      />
                      <div class="pt-4 text-center">
                        <h5 class="title">
                          <span class="d-block mb-1">Patrícia | Paraná</span>
                          <small class="h6 text-muted">Atendemos em todo Brasil</small>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 mb-5 mb-lg-0">
                    <div class="px-4">
                      <b-embed
                          aspect="1by1"
                          src="https://www.youtube.com/embed/8RDDxkz9NWc"
                      />
                      <div class="pt-4 text-center">
                        <h5 class="title">
                          <span class="d-block mb-1">Tatiane | Goiânia</span>
                          <small class="h6 text-muted">Atendemos em todo Brasil</small>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 mb-5 mb-lg-0">
                    <div class="px-4">
                      <b-embed
                          aspect="1by1"
                          src="https://www.youtube.com/embed/rXVjZcxKjnc"
                      />
                      <div class="pt-4 text-center">
                        <h5 class="title">
                          <span class="d-block mb-1">Ieda | Ourinhos</span>
                          <small class="h6 text-muted">Atendemos em todo Brasil</small>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-0">
            <div class="container">
                <card gradient="my-text-logo"
                      no-body
                      shadow-size="lg"
                      class="border-0">
                    <div class="p-5">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <h3 class="text-white">Não perca tempo e fale conosco AGORA para começar seu processo e receber seu BENEFÍCIO.</h3>
                            </div>
                            <div class="col-lg-3 ml-lg-auto mt-4">
                              <a onclick="handleButton()" class="btn_whats btn-lead-button">
                                <i class="fa fa-whatsapp mr-2"></i>
                                Falar Agora
                              </a>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section class="section section-shaped bg-none my-0">
            <div class="shape shape-style-3 bg-gradient-my-primary shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Nossa Empresa</h2>
                        <p class="lead text-white">Visite a AMO, estamos prontos para te receber.</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="fa fa-address-card-o" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Endereço</h5>
                        <a href="#" class="text-white mt-3">Rua Afonso Celso, 530 | Vila Mariana |
                          04119-002  - São Paulo/SP.</a>

                    </div>
                  <div class="col-lg-4">
                    <icon name="fa fa-whatsapp" size="lg" gradient="white" shadow round color="primary"></icon>
                    <h5 class="text-white mt-3">Telefone</h5>
                    <a onclick="handleButton()" target="_blank"
                       class="text-white mt-3 btn-lead-button">(11) 91351-7608</a>
                  </div>
                  <div class="col-lg-4">
                    <icon name="fa fa-envelope" size="lg" gradient="white" shadow round color="primary"></icon>
                    <h5 class="text-white mt-3">Email</h5>
                    <a href="mailto:atendimento@auxiliomaternidadeoficial.com.br" target="_blank"
                       class="text-white mt-3 b-all mr-4">atendimento@auxiliomaternidadeoficial.com.br</a>
                  </div>
                </div>
            </div>
        </section>
<!--      <div class="icon-fixed">-->
<!--        <a onclick="handleButton()" class="icon-fixed__content h-100 w-100 bg-whats">-->
<!--          <i class="icon-fixed&#45;&#45;icon fa fa-whatsapp"></i>-->
<!--        </a>-->
<!--      </div>-->
    </div>
</template>

<script>
import { BEmbed } from 'bootstrap-vue'
import config from '../../config'

export default {
  name: 'home',
  components: {
    BEmbed
  },
  data: () => ({
    url: config.links.whatsapp
  })
}
</script>
<style lang="scss" scoped>
@import "src/assets/scss/my-custom";

.icon-fixed {
  width: 5rem;
  height: 5rem;
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 11;

  &--icon {
    color: white;
    font-size: 36px;
  }

  &__content {
    background-color: #2DCE89;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 4px 4px 4px #00000030;
  }
}

.container {
  .txt-primary {
    color: $my-primary;
  }
  .txt-secondary {
    color: $my-secondary;
  }
  .txt-logo {
    color: $my-text-logo;
  }
  p.p-txt {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .section-bt-center {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  }
}
.bg-none {
  background: none;
}

</style>
